<header id="main-header" theme>
  <div class="menu-toggle" (click)="toggelSidebar()">
    <div></div>
    <div></div>
    <div></div>
  </div>
  <div class="logo">
    <a [routerLink]="['/']">
      <img src="{{userProfile?.companyLogoPath}}" alt="{{userProfile?.company}}" height="25"/>
    </a>
  </div>

  <div class="ml-md-auto"></div>

  <div class="header-part-right" *ngIf="isAuthenticated()">
    <!-- notifications -->
    <div ngbDropdown [placement]="'bottom-right'">
      <div class="badge-top-container">
        <i ngbDropdownToggle class="fal fa-bell header-icon" role="button"></i>
      </div>
      <div ngbDropdownMenu class="notification-dropdown rtl-ps-none">
        <div class="dropdown-item d-flex" *ngFor="let item of notifications" [routerLink]="[item.link]">
          <div class="notification-icon">
            <i class="{{ item.icon }} text-{{ item.status }} me-1"></i>
          </div>
          <div class="notification-details flex-grow-1">
            <p class="m-0 d-flex align-items-center">
              <span>{{ item.title }}</span>
              <span *ngIf="item.badge" class="badge badge-pill badge-{{ item.status }} ms-1 me-1">{{
                item.badge
              }}</span>
              <span class="flex-grow-1"></span>
              <span class="text-small text-muted ms-auto">{{ item.time | date: 'dd/MM/yyyy' }}</span>
            </p>
            <p class="text-small text-muted m-0">{{ item.text | excerpt: 30 }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- filter -->
    <div ngbDropdown #filterDrop="ngbDropdown" placement="bottom-right">
      <div class="badge-top-container">
        <i ngbDropdownToggle class="far fa-building header-icon" role="button"></i>
      </div>

      <div ngbDropdownMenu aria-labelledby="userDropdown" class="header-account-dropdown card-filter-company">
        <app-filter-company (close)="filterDrop.close()"></app-filter-company>
      </div>
    </div>

    <!-- account -->
    <div ngbDropdown [placement]="'bottom-right'" class="user col">
      <span id="userDropdown" ngbDropdownToggle alt="">
        <i class="fal fa-user header-icon" role="button"></i>
        <span class="name-user">Olá{{userProfile?.shortName ? ', '+userProfile?.shortName : '' }}</span>
        <i class="fal fa-angle-down ms-2"></i>
      </span>
      <div ngbDropdownMenu aria-labelledby="userDropdown" class="header-account-dropdown">
        <a [routerLink]="['/logout']" class="dropdown-item">
          <i class="fal fa-angle-right dynamic-primary-color"></i>
          Sair
        </a>
      </div>
    </div>
  </div>
</header>
